"use client"

import { useEffect, useState } from 'react';
import CompanyService from '@/api/companies.service';
import { ArrowLeft, Loader2, Edit2 } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import { Button } from '@/components/ui/button';
import FormModal from '@/components/FormModal';
import { EditCompanyForm } from '@/pages/companies/EditCompanyForm';

interface CompanyDetailsProps {
  publicId: string;
}

export default function Company({ publicId }: CompanyDetailsProps) {
  const [isModalOpen, setModalOpen] = useState(false);
  const [company, setCompany] = useState<any>(null);
  const { toast } = useToast();
  useEffect(() => {
    const fetchCompany = async () => {
      const response = await CompanyService.getCompany(publicId);
      console.log("response.data", response.data);
      if (response.data.result === 'invalid') {
        window.location.href = '/logout';
      } else if (response.data.result === 'success') {
        setCompany(response.data.company);
      } else {
        toast({
          title: "Error",
          description: response.data.message,
          variant: "destructive",
        });
      }
    };
    publicId && fetchCompany();
  }, [publicId]);

  if (!company) {
    return <div className="flex justify-center items-center h-screen"><Loader2 className="animate-spin" /></div>;
  }

  return (
    <div className="container py-10 mx-auto bg-white px-10 rounded-lg">
      <div className="px-4 sm:px-0">
        <Button onClick={() => window.history.back()} className='mr-2'> 
        <ArrowLeft className="w-4 h-4 mr-2" /> Go Back</Button>
        <Button onClick={() => setModalOpen(true)} className='mr-2 bg-[#0E415E] hover:bg-[#1F628D] text-white'>
          <Edit2 className="w-4 h-4 mr-2" />
          Edit
        </Button>
        <FormModal
            open={isModalOpen}
            setOpen={setModalOpen}
            title="Update Company"
          >
            <EditCompanyForm company={company} />
          </FormModal>
        <h3 className="text-base font-semibold text-gray-900 mt-5">Company Information</h3>
        <p className="mt-1 max-w-2xl text-sm text-gray-500">Details about the company.</p>
      </div>
      <div className="mt-6">
        <dl className="grid grid-cols-1 sm:grid-cols-2">
          <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-bold text-gray-900">Name</dt>
            <dd className="mt-1 text-sm text-gray-700 sm:mt-2">{company.name}</dd>
          </div>
          <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-bold text-gray-900">Email Address</dt>
            <dd className="mt-1 text-sm text-gray-700 sm:mt-2">{company.emailAddress}</dd>
          </div>
          <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-bold text-gray-900">Phone Number</dt>
            <dd className="mt-1 text-sm text-gray-700 sm:mt-2">{company.phoneNumber}</dd>
          </div>
          <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-bold text-gray-900">Address</dt>
            <dd className="mt-1 text-sm text-gray-700 sm:mt-2">{company.address}, {company.city}, {company.state}, {company.country}</dd>
          </div>
          <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-bold text-gray-900">Postal Code</dt>
            <dd className="mt-1 text-sm text-gray-700 sm:mt-2">{company.postalCode}</dd>
          </div>
          <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-bold text-gray-900">Website</dt>
            <dd className="mt-1 text-sm text-gray-700 sm:mt-2">{company.website}</dd>
          </div>
        </dl>
      </div>
    </div>
  )
}
